export { Rating } from './Rating';
export type { Props } from './Rating.types';
